import {Component} from "@angular/core";
import {TranslateModule} from "@ngx-translate/core";
import {BtwAcademyHeader} from "./btw-academy-header/btw-academy-header";
import {BtwAcademyInfoCard} from "./models/btw-academy-info-card";
import {BoxItemFlip} from "../../components/display/box-item-flip/box-item-flip";

@Component({
  selector: 'en-btw-academy',
  standalone: true,
  imports: [
    TranslateModule,
    BtwAcademyHeader,
    BoxItemFlip
  ],
  styleUrls: ['./btw-academy.scss'],
  templateUrl: 'en-btw-academy.html'
})
export class EnBtwAcademy {
  protected infoCards: BtwAcademyInfoCard[] = [
    {
      title: 'MiniTrooper Student Learning Program',
      imgClass: 'flip-card-btw-16',
      description: 'MiniTrooper Student Learning Program',
      content: 'Developed by BMW TechWorks Romania, is an educational initiative designed to nurture and integrate talented young individuals into the world of technology.\n' +
        'The program gives students the opportunity to combine academic learning with practical experience in a real working environment, discovering how innovation takes shape inside a global tech company.\n' +
        '\n' +
        'Students participate in a hybrid learning format – both at the BMW TechWorks Romania headquarters in Cluj-Napoca and online – benefiting from mentorship, applied activities, and exposure to real industry processes.\n' +
        'MiniTrooper offers a complete professional learning experience and serves as a launchpad for future careers in technology.'
    }, {
      title: 'Science Café – the lab where ideas and research come to life',
      imgClass: 'flip-card-btw-10-large',
      description: 'Science Café',
      content: 'Is the co-creation, research, and experimentation lab within BMW TechWorks Romania, open to students, professors, and young tech enthusiasts.\n' +
        'It hosts workshops, applied research sessions, prototyping, concept testing, hackathons, and innovation projects focused on emerging technologies such as artificial intelligence, sustainability, digital mobility, and software engineering.\n' +
        '\n' +
        'The lab can be reserved by students for educational or creative purposes, based on a request sent to 👉 office@bmwtechworks.ro.\n' +
        'A space for collaboration, research, and creativity – where ideas evolve into real projects.'
    }
  ];
}
